<template>
  <modal
    name="charge-card-modal"
    transition="pop-out"
    class="charge-card-modal"
    :width="500"
    :focus-trap="false"
    :clickToClose="false"
    height="auto"
    @before-open="onBeforeOpen"
    v-model="show"
  >
    <div class="position-relative modal-outer-container">
      <div class="modal-header border-bottom">
        <span class="ml-3 pl-2 font-weight-bold">Manual Card Charge</span>
        <button class="btn border-0" @click="closeModal" type="button">
          <i class="fas fa-times fa-lg"></i>
        </button>
      </div>

      <form @submit.prevent="submitCharge">
        <div class="col-12 modal-body">
          <p v-if="card" class="text-muted mb-3">
            Charging
            <strong>{{ $filters.capitalize(card.brand) }}</strong>
            card ending in
            <strong>{{ card.last4 }}</strong>
          </p>

          <div class="form-group">
            <label>Amount ($) <span class="text-danger">*</span></label>
            <input
              v-model.number="amount"
              type="number"
              class="form-control"
              placeholder="e.g. 75.00"
              min="0.50"
              step="0.01"
              required
            />
          </div>

          <div class="form-group">
            <label
              >Description <span class="text-muted">(optional)</span></label
            >
            <input
              v-model.trim="description"
              type="text"
              class="form-control"
              placeholder="e.g. Session payment"
              maxlength="500"
            />
          </div>
        </div>

        <div
          class="
            d-flex
            justify-content-center
            border-top
            align-items-center
            py-3
          "
        >
          <button
            class="btn btn-secondary mr-3"
            @click.prevent="closeModal"
            type="button"
          >
            Cancel
          </button>
          <save classes="btn btn-success" :saving="isSaving" type="submit">
            Charge Card
          </save>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions, mapState } from "vuex";

export default {
  name: "ChargeCardModal",
  props: {
    card: {
      type: Object,
      default: null,
    },
    patientUserId: {
      type: Number,
      required: true,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      amount: "",
      description: "",
    };
  },
  computed: {
    ...mapState({
      isSaving: (state) => state.transactions.isSaving,
    }),
    show: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    ...mapActions({
      chargeCard: "transactions/chargeCard",
    }),
    onBeforeOpen() {
      this.amount = "";
      this.description = "";
    },
    submitCharge: async function () {
      if (!this.card) {
        Swal.fire("Error", "No card selected.", "error");
        return;
      }

      const result = await this.chargeCard({
        user_id: this.patientUserId,
        amount: this.amount,
        description: this.description || null,
        card_id: this.card.id,
      });

      if (result) {
        Swal.fire({
          title: "Success",
          text: `$${parseFloat(this.amount).toFixed(2)} charged successfully.`,
          icon: "success",
        });
        this.$emit("charged", result);
        this.closeModal();
      }
    },
    closeModal() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.charge-card-modal {
  .modal-body {
    padding: 1.5rem 1rem;
  }
}
</style>
